import type FilterParams from '../types/FilterParams';
import type QueryProviderQuery from '../types/QueryProviderQuery';
import type SortableFields from '../types/SortableFields';
import parseFilterParams from './parseFilterParams';
import parsePaginationParams from './parsePaginationParams';
import parseSortableFields from './parseSortableFields';

const getQuery = <FiltersType = Record<string, unknown>>({
  defaultPageSize,
  filterParams,
  filterPrefix,
  isPaginated,
  paginationPrefix,
  searchString,
  sortableFields,
  sortingPrefix,
}: {
  defaultPageSize: number;
  filterParams: FilterParams;
  filterPrefix?: string;
  isPaginated: boolean;
  paginationPrefix?: string;
  searchString: string;
  sortableFields: SortableFields;
  sortingPrefix?: string;
}): QueryProviderQuery<FiltersType> => {
  const search = new URLSearchParams(searchString);
  let query = parseFilterParams<FiltersType>(
    filterParams,
    search,
    filterPrefix,
  );
  if (isPaginated) {
    query = {
      ...query,
      ...parsePaginationParams(defaultPageSize, search, paginationPrefix),
    };
  }
  if (sortableFields && Object.keys(sortableFields).length) {
    query = {
      ...query,
      ...parseSortableFields(sortableFields, search, sortingPrefix),
    };
  }
  return query as QueryProviderQuery<FiltersType>;
};

export default getQuery;
